<template>
  <div class="profile-header-card mb-2">
    <div class="profile-header">
      <div class="profile-header__overlay" />
      <div class="profile-header__body">
        <div class="profile-header__left">
          <div
            class="profile-header__avatar-wrapper"
            @click="$refs.avatarInput.click()"
          >
            <div
              v-if="avatarPreview || form.image"
              class="profile-header__avatar"
            >
              <b-img
                :src="avatarPreview || form.image"
                rounded="circle"
                width="110"
                height="110"
                alt="Profile"
              />
            </div>
            <div
              v-else
              class="profile-header__avatar profile-header__avatar--initials"
            >
              {{ initials }}
            </div>
            <div class="profile-header__avatar-overlay">
              <feather-icon
                icon="CameraIcon"
                size="22"
              />
              <span>Change</span>
            </div>
            <b-spinner
              v-if="isUploadingAvatar"
              small
              variant="light"
              class="profile-header__avatar-spinner"
            />
          </div>
          <input
            ref="avatarInput"
            type="file"
            accept="image/png, image/jpeg, image/webp"
            class="d-none"
            @change="$emit('avatar-selected', $event)"
          >
        </div>

        <div class="profile-header__info">
          <h2 class="profile-header__name">
            {{ form.name || 'User' }}
          </h2>
          <div class="profile-header__meta">
            <span v-if="form.email">
              <feather-icon
                icon="MailIcon"
                size="15"
                class="mr-50"
              />
              {{ form.email }}
            </span>
            <span v-if="form.phone">
              <feather-icon
                icon="PhoneIcon"
                size="15"
                class="mr-50"
              />
              {{ form.phone }}
            </span>
          </div>
          <div class="profile-header__badges">
            <span
              v-if="form.job_description"
              class="profile-badge"
            >
              <feather-icon
                icon="BriefcaseIcon"
                size="13"
                class="mr-25"
              />
              {{ form.job_description }}
            </span>
            <span
              v-if="form.nationality"
              class="profile-badge"
            >
              <feather-icon
                icon="FlagIcon"
                size="13"
                class="mr-25"
              />
              {{ form.nationality }}
            </span>
            <span
              v-if="form.joined_at"
              class="profile-badge"
            >
              <feather-icon
                icon="CalendarIcon"
                size="13"
                class="mr-25"
              />
              Joined {{ form.joined_at }}
            </span>
          </div>
        </div>

        <div
          v-if="form.token"
          class="profile-qr-card"
        >
          <div class="profile-qr-card__title">
            <feather-icon
              icon="GridIcon"
              size="16"
              class="mr-50"
            />
            QR Code
          </div>

          <div class="profile-qr-card__qr">
            <QrcodeVue
              v-if="profileQrValue"
              :value="profileQrValue"
              :size="110"
              level="H"
              :background="isDarkLayout ? '#212121ff' : '#ffffff'"
              foreground="#0564f2ff"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'ProfileHeader',
  components: {
    QrcodeVue,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    initials: {
      type: String,
      required: true,
    },
    avatarPreview: {
      type: [String, null],
      default: () => null,
    },
    isUploadingAvatar: {
      type: Boolean,
      default: () => false,
    },
    profileQrValue: {
      type: String,
      default: () => '',
    },
    isDarkLayout: {
      type: Boolean,
      default: () => false,
    },
  },
}
</script>
